import { render } from "./PreviewSymbol.vue?vue&type=template&id=0c4d0678&scoped=true&ts=true"
import script from "./PreviewSymbol.vue?vue&type=script&lang=ts"
export * from "./PreviewSymbol.vue?vue&type=script&lang=ts"

import "./PreviewSymbol.vue?vue&type=style&index=0&id=0c4d0678&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4d0678"]])

export default __exports__